// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This style file is imported by UserTable.js which displays user information in table format.
*/

.table-container-user {
    width: 85% !important;
    margin: 2% auto;
}

.user-table-div-tbody {
    display: block;
    max-height: 75vh;
    min-height: 60vh;
    overflow-y: auto;
    overflow-x: hidden;
}

.user-table-div-tbody::-webkit-scrollbar {
    width: 8px;
}

.user-table-div-tbody::-webkit-scrollbar-track {
    background: #f2f2f2;
    border-radius: 8px;
}

.user-table-div-tbody::-webkit-scrollbar-thumb {
    background: #0C3135;
    border-radius: 8px;
}

.user-table-div-tbody::-webkit-scrollbar-thumb:hover {
    background: #ddd;
}

.user-table-thead {
    background-color: #f2f2f2;
    position: sticky;
    top: 0;
    z-index: 2;
}

.time-container-user {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 1% 1% !important;
    gap: 1% !important;
    margin-top: 4%;
}

.user-stats {
    display: flex;
    gap: 20px;
    margin-right: auto;
    font-size: 14px;
    color: #0C3135;
    font-weight: 500;
    align-items: center;
    flex-wrap: wrap;
}

.filtered-count {
    color: #4a90e2;
    font-weight: 600;
    font-size: 14px;
}

.user-count,
.active-count {
    background-color: transparent;
    padding: 5px 10px;
    border-radius: 4px;
    border: none;
}

.user-table {
    width: 100% !important;
    border-collapse: collapse;
    margin-top: 15px;
    height: 60vh;
}

.user-td {
    border: 1px solid #ddd;
    text-align: left !important;
    padding: 8px 12px;
    word-wrap: break-word;
    max-width: 250px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.user-th {
    top: 0;
    position: sticky;
    background-color: #0C3135;
    border: 1px solid #ddd;
    text-align: center !important;
    padding: 8px 12px;
    min-width: 120px;
    max-width: 250px;
    max-height: 55vh;
    color: white;
}

.user-table tr {
    display: table;
    width: 100%;
    table-layout: fixed;
}

.tr-user:nth-child(even) {
    background-color: #f9f9f9;
}

.tr-user:hover {
    background-color: #ddd;
}

.refresh-button-user {
    background-color: #0C3135;
    color: white;
    font-size: 15px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    padding: 0.5rem;
    height: 2.0rem !important;
    width: 2.0rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.refresh-button-user:hover {
    background-color: #2a5a5a;
}

.table-header-content-user {
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    padding: 0 5px;
}

.table-heading-user-name,
.table-heading-user-email,
.table-heading-user-uid {
    margin-right: 10px;
}

.sort-arrows-user {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.arrow-user {
    cursor: pointer;
    font-size: 12px;
    line-height: 1;
    -webkit-user-select: none;
            user-select: none;
    color: rgba(255, 255, 255, 0.8);
    transition: color 0.2s ease;
}

.arrow-user:hover {
    color: white;
}

/* .arrow-user.active {
  color: #4CAF50;
} */

.status-badge {
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    text-align: center;
    display: inline-block;
    min-width: 60px;
}

.status-badge.active {
    background-color: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
}

.status-badge.inactive {
    background-color: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
}

.status-badge.disabled {
    background-color: #e2e3e5;
    color: #495057;
    border: 1px solid #d6d8db;
}

.status-badge.locked {
    background-color: #fff3cd;
    color: #856404;
    border: 1px solid #ffeaa7;
}

.status-message {
    text-align: center;
    padding: 20px;
    font-style: italic;
    color: #666;
}

.status-message-error {
    text-align: center;
    padding: 20px;
    color: #d32f2f;
    background-color: #ffebee;
    border: 1px solid #ffcdd2;
    border-radius: 4px;
}

.loading {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
}

.loading img {
    width: 32px;
    height: 32px;
}

.action-buttons {
    display: flex;
    gap: 10px;
    align-items: center;
}

/* Search container */
.search-container-user {
    margin-bottom: 20px;
    padding: 0 20px;
    
}

.search-input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    /* max-width: 500px; */
    margin: 0 auto;
}

.search-input-user {
    width: 70% !important;
    padding: 10px 15px 10px 15px;
    border: 2px solid #e0e0e0;
    border-radius: 25px;
    font-size: 14px;
    outline: none;
    transition: all 0.3s ease;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-left: 75%;
}

.search-input-user:focus {
    border-color: #4a90e2;
    box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.1);
}

.search-input-user::placeholder {
    color: #888;
    font-style: italic;
}

.search-icon {
    position: absolute;
    left: 15px;
    color: #888;
    font-size: 16px;
    z-index: 1;
}

.clear-search-button {
    position: absolute;
    right: 15px;
    background: none;
    border: none;
    color: #888;
    cursor: pointer;
    font-size: 14px;
    padding: 5px;
    border-radius: 50%;
    transition: all 0.3s ease;
}

.clear-search-button:hover {
    color: #ff4444;
    background-color: rgba(255, 68, 68, 0.1);
}

/* Mobile Responsive Design */
@media screen and (max-width: 321px) {
    .table-container-user {
        width: 95% !important;
    }

    .time-container-user {
        flex-direction: column;
        gap: 10px;
        padding: 2% 5%;
        margin-top: 10%;
    }

    .user-stats {
        flex-direction: column;
        gap: 5px;
        margin-right: 0;
    }

    .user-table {
        width: 90% !important;
        margin-left: 5%;
        font-size: 12px;
    }

    .user-td,
    .user-th {
        padding: 6px 8px;
        max-width: 80px;
    }
}

@media (min-width: 321px) and (max-width: 376px) {
    .table-container-user {
        width: 95% !important;
    }

    .time-container-user {
        flex-direction: column;
        gap: 10px;
        padding: 2% 2%;
        margin-top: 15%;
    }

    .user-stats {
        margin-right: 0;
    }

    .user-table {
        width: 95% !important;
        margin-left: 3%;
        font-size: 13px;
    }
}

@media (min-width: 376px) and (max-width: 426px) {
    .table-container-user {
        width: 95% !important;
    }

    .time-container-user {
        flex-wrap: wrap;
        padding: 1% 1%;
        margin-top: 15%;
        gap: 10px;
    }

    .user-table {
        width: 95% !important;
        margin-left: 3%;
    }
}

@media (min-width: 426px) and (max-width: 769px) {
    .table-container-user {
        width: 90% !important;
    }

    .time-container-user {
        padding: 0% 0%;
        margin-top: 8%;
        gap: 15px;
    }

    .user-table {
        width: 97% !important;
        margin-left: 2%;
    }

    .user-table-div-tbody {
        height: 85vh !important;
    }
}

@media (min-width: 769px) and (max-width: 1025px) {
    .time-container-user {
        padding: 0% 0%;
        margin-top: 5%;
        gap: 20px;
    }

    .user-table-div-tbody {
        height: 85vh !important;
    }
}

@media (min-width: 1921px) {
    .user-table thead {
        font-size: 22px !important;
    }

    .user-table tbody {
        font-size: 22px !important;
    }

    .user-table-div-tbody {
        height: 85vh !important;
    }

    .user-stats {
        font-size: 18px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/HarnessUser/HarnessUser.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED;IACI,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,MAAM;IACN,UAAU;AACd;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;IAEI,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,MAAM;IACN,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;;;IAGI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;IACd,yBAAiB;YAAjB,iBAAiB;IACjB,+BAA+B;IAC/B,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;;GAEG;;AAEH;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI,mBAAmB;IACnB,eAAe;;AAEnB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,4BAA4B;IAC5B,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,wCAAwC;IACxC,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,eAAe;IACf,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,wCAAwC;AAC5C;;AAEA,6BAA6B;AAC7B;IACI;QACI,qBAAqB;IACzB;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,QAAQ;QACR,eAAe;IACnB;;IAEA;QACI,qBAAqB;QACrB,eAAe;QACf,eAAe;IACnB;;IAEA;;QAEI,gBAAgB;QAChB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,qBAAqB;IACzB;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,qBAAqB;QACrB,eAAe;QACf,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,qBAAqB;IACzB;;IAEA;QACI,eAAe;QACf,cAAc;QACd,eAAe;QACf,SAAS;IACb;;IAEA;QACI,qBAAqB;QACrB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,qBAAqB;IACzB;;IAEA;QACI,cAAc;QACd,cAAc;QACd,SAAS;IACb;;IAEA;QACI,qBAAqB;QACrB,eAAe;IACnB;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,cAAc;QACd,cAAc;QACd,SAAS;IACb;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/*\r\nThis style file is imported by UserTable.js which displays user information in table format.\r\n*/\r\n\r\n.table-container-user {\r\n    width: 85% !important;\r\n    margin: 2% auto;\r\n}\r\n\r\n.user-table-div-tbody {\r\n    display: block;\r\n    max-height: 75vh;\r\n    min-height: 60vh;\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n}\r\n\r\n.user-table-div-tbody::-webkit-scrollbar {\r\n    width: 8px;\r\n}\r\n\r\n.user-table-div-tbody::-webkit-scrollbar-track {\r\n    background: #f2f2f2;\r\n    border-radius: 8px;\r\n}\r\n\r\n.user-table-div-tbody::-webkit-scrollbar-thumb {\r\n    background: #0C3135;\r\n    border-radius: 8px;\r\n}\r\n\r\n.user-table-div-tbody::-webkit-scrollbar-thumb:hover {\r\n    background: #ddd;\r\n}\r\n\r\n.user-table-thead {\r\n    background-color: #f2f2f2;\r\n    position: sticky;\r\n    top: 0;\r\n    z-index: 2;\r\n}\r\n\r\n.time-container-user {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n    padding: 1% 1% !important;\r\n    gap: 1% !important;\r\n    margin-top: 4%;\r\n}\r\n\r\n.user-stats {\r\n    display: flex;\r\n    gap: 20px;\r\n    margin-right: auto;\r\n    font-size: 14px;\r\n    color: #0C3135;\r\n    font-weight: 500;\r\n    align-items: center;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.filtered-count {\r\n    color: #4a90e2;\r\n    font-weight: 600;\r\n    font-size: 14px;\r\n}\r\n\r\n.user-count,\r\n.active-count {\r\n    background-color: transparent;\r\n    padding: 5px 10px;\r\n    border-radius: 4px;\r\n    border: none;\r\n}\r\n\r\n.user-table {\r\n    width: 100% !important;\r\n    border-collapse: collapse;\r\n    margin-top: 15px;\r\n    height: 60vh;\r\n}\r\n\r\n.user-td {\r\n    border: 1px solid #ddd;\r\n    text-align: left !important;\r\n    padding: 8px 12px;\r\n    word-wrap: break-word;\r\n    max-width: 250px;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n\r\n.user-th {\r\n    top: 0;\r\n    position: sticky;\r\n    background-color: #0C3135;\r\n    border: 1px solid #ddd;\r\n    text-align: center !important;\r\n    padding: 8px 12px;\r\n    min-width: 120px;\r\n    max-width: 250px;\r\n    max-height: 55vh;\r\n    color: white;\r\n}\r\n\r\n.user-table tr {\r\n    display: table;\r\n    width: 100%;\r\n    table-layout: fixed;\r\n}\r\n\r\n.tr-user:nth-child(even) {\r\n    background-color: #f9f9f9;\r\n}\r\n\r\n.tr-user:hover {\r\n    background-color: #ddd;\r\n}\r\n\r\n.refresh-button-user {\r\n    background-color: #0C3135;\r\n    color: white;\r\n    font-size: 15px;\r\n    border: none;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    padding: 0.5rem;\r\n    height: 2.0rem !important;\r\n    width: 2.0rem;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.refresh-button-user:hover {\r\n    background-color: #2a5a5a;\r\n}\r\n\r\n.table-header-content-user {\r\n    display: flex;\r\n    align-items: center;\r\n    text-align: center;\r\n    justify-content: center;\r\n    padding: 0 5px;\r\n}\r\n\r\n.table-heading-user-name,\r\n.table-heading-user-email,\r\n.table-heading-user-uid {\r\n    margin-right: 10px;\r\n}\r\n\r\n.sort-arrows-user {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 2px;\r\n}\r\n\r\n.arrow-user {\r\n    cursor: pointer;\r\n    font-size: 12px;\r\n    line-height: 1;\r\n    user-select: none;\r\n    color: rgba(255, 255, 255, 0.8);\r\n    transition: color 0.2s ease;\r\n}\r\n\r\n.arrow-user:hover {\r\n    color: white;\r\n}\r\n\r\n/* .arrow-user.active {\r\n  color: #4CAF50;\r\n} */\r\n\r\n.status-badge {\r\n    padding: 4px 8px;\r\n    border-radius: 12px;\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n    text-align: center;\r\n    display: inline-block;\r\n    min-width: 60px;\r\n}\r\n\r\n.status-badge.active {\r\n    background-color: #d4edda;\r\n    color: #155724;\r\n    border: 1px solid #c3e6cb;\r\n}\r\n\r\n.status-badge.inactive {\r\n    background-color: #f8d7da;\r\n    color: #721c24;\r\n    border: 1px solid #f5c6cb;\r\n}\r\n\r\n.status-badge.disabled {\r\n    background-color: #e2e3e5;\r\n    color: #495057;\r\n    border: 1px solid #d6d8db;\r\n}\r\n\r\n.status-badge.locked {\r\n    background-color: #fff3cd;\r\n    color: #856404;\r\n    border: 1px solid #ffeaa7;\r\n}\r\n\r\n.status-message {\r\n    text-align: center;\r\n    padding: 20px;\r\n    font-style: italic;\r\n    color: #666;\r\n}\r\n\r\n.status-message-error {\r\n    text-align: center;\r\n    padding: 20px;\r\n    color: #d32f2f;\r\n    background-color: #ffebee;\r\n    border: 1px solid #ffcdd2;\r\n    border-radius: 4px;\r\n}\r\n\r\n.loading {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding: 20px;\r\n}\r\n\r\n.loading img {\r\n    width: 32px;\r\n    height: 32px;\r\n}\r\n\r\n.action-buttons {\r\n    display: flex;\r\n    gap: 10px;\r\n    align-items: center;\r\n}\r\n\r\n/* Search container */\r\n.search-container-user {\r\n    margin-bottom: 20px;\r\n    padding: 0 20px;\r\n    \r\n}\r\n\r\n.search-input-wrapper {\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    /* max-width: 500px; */\r\n    margin: 0 auto;\r\n}\r\n\r\n.search-input-user {\r\n    width: 70% !important;\r\n    padding: 10px 15px 10px 15px;\r\n    border: 2px solid #e0e0e0;\r\n    border-radius: 25px;\r\n    font-size: 14px;\r\n    outline: none;\r\n    transition: all 0.3s ease;\r\n    background-color: #fff;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n    margin-left: 75%;\r\n}\r\n\r\n.search-input-user:focus {\r\n    border-color: #4a90e2;\r\n    box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.1);\r\n}\r\n\r\n.search-input-user::placeholder {\r\n    color: #888;\r\n    font-style: italic;\r\n}\r\n\r\n.search-icon {\r\n    position: absolute;\r\n    left: 15px;\r\n    color: #888;\r\n    font-size: 16px;\r\n    z-index: 1;\r\n}\r\n\r\n.clear-search-button {\r\n    position: absolute;\r\n    right: 15px;\r\n    background: none;\r\n    border: none;\r\n    color: #888;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    padding: 5px;\r\n    border-radius: 50%;\r\n    transition: all 0.3s ease;\r\n}\r\n\r\n.clear-search-button:hover {\r\n    color: #ff4444;\r\n    background-color: rgba(255, 68, 68, 0.1);\r\n}\r\n\r\n/* Mobile Responsive Design */\r\n@media screen and (max-width: 321px) {\r\n    .table-container-user {\r\n        width: 95% !important;\r\n    }\r\n\r\n    .time-container-user {\r\n        flex-direction: column;\r\n        gap: 10px;\r\n        padding: 2% 5%;\r\n        margin-top: 10%;\r\n    }\r\n\r\n    .user-stats {\r\n        flex-direction: column;\r\n        gap: 5px;\r\n        margin-right: 0;\r\n    }\r\n\r\n    .user-table {\r\n        width: 90% !important;\r\n        margin-left: 5%;\r\n        font-size: 12px;\r\n    }\r\n\r\n    .user-td,\r\n    .user-th {\r\n        padding: 6px 8px;\r\n        max-width: 80px;\r\n    }\r\n}\r\n\r\n@media (min-width: 321px) and (max-width: 376px) {\r\n    .table-container-user {\r\n        width: 95% !important;\r\n    }\r\n\r\n    .time-container-user {\r\n        flex-direction: column;\r\n        gap: 10px;\r\n        padding: 2% 2%;\r\n        margin-top: 15%;\r\n    }\r\n\r\n    .user-stats {\r\n        margin-right: 0;\r\n    }\r\n\r\n    .user-table {\r\n        width: 95% !important;\r\n        margin-left: 3%;\r\n        font-size: 13px;\r\n    }\r\n}\r\n\r\n@media (min-width: 376px) and (max-width: 426px) {\r\n    .table-container-user {\r\n        width: 95% !important;\r\n    }\r\n\r\n    .time-container-user {\r\n        flex-wrap: wrap;\r\n        padding: 1% 1%;\r\n        margin-top: 15%;\r\n        gap: 10px;\r\n    }\r\n\r\n    .user-table {\r\n        width: 95% !important;\r\n        margin-left: 3%;\r\n    }\r\n}\r\n\r\n@media (min-width: 426px) and (max-width: 769px) {\r\n    .table-container-user {\r\n        width: 90% !important;\r\n    }\r\n\r\n    .time-container-user {\r\n        padding: 0% 0%;\r\n        margin-top: 8%;\r\n        gap: 15px;\r\n    }\r\n\r\n    .user-table {\r\n        width: 97% !important;\r\n        margin-left: 2%;\r\n    }\r\n\r\n    .user-table-div-tbody {\r\n        height: 85vh !important;\r\n    }\r\n}\r\n\r\n@media (min-width: 769px) and (max-width: 1025px) {\r\n    .time-container-user {\r\n        padding: 0% 0%;\r\n        margin-top: 5%;\r\n        gap: 20px;\r\n    }\r\n\r\n    .user-table-div-tbody {\r\n        height: 85vh !important;\r\n    }\r\n}\r\n\r\n@media (min-width: 1921px) {\r\n    .user-table thead {\r\n        font-size: 22px !important;\r\n    }\r\n\r\n    .user-table tbody {\r\n        font-size: 22px !important;\r\n    }\r\n\r\n    .user-table-div-tbody {\r\n        height: 85vh !important;\r\n    }\r\n\r\n    .user-stats {\r\n        font-size: 18px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
